import { ReverifyRequest, VerificationStatus } from "shared/types";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { HugeiconsIcon } from "@hugeicons/react";
import { Loading03Icon } from "@hugeicons-pro/core-stroke-rounded";

interface Props {
  income: CombinedIncome;
  applicationId?: number | string;
  verificationId?: number | string;
  applicantId?: number | string;
  pendingReverifyRequest?: ReverifyRequest | null;
  verificationStatus?: VerificationStatus;
  onCancelled?: () => void;
}

export const ProcessingStatus = ({ income }: Props) => {
  if (income.status !== "processing") return null;

  return (
    <div className="flex flex-col items-center justify-center min-h-[250px] w-full mx-auto">
      <div className="size-16 shrink-0 bg-warning-50 rounded-full flex items-center justify-center mb-6 mx-auto">
        <HugeiconsIcon
          icon={Loading03Icon}
          size={24}
          className="text-warning-600"
        />
      </div>

      <h2 className="text-base font-bold text-content-500 mb-2 text-center">
        Verifying income source with documents...
      </h2>

      <p className="text-center text-sm font-medium text-content-300 mb-4">
        Verification may take up to an hour
      </p>
    </div>
  );
};
